import { render } from "./ProgramBuilder.vue?vue&type=template&id=6f4908f5&scoped=true&ts=true"
import script from "./ProgramBuilder.vue?vue&type=script&lang=ts"
export * from "./ProgramBuilder.vue?vue&type=script&lang=ts"

import "./ProgramBuilder.vue?vue&type=style&index=0&id=6f4908f5&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4908f5"]])

export default __exports__